// Text palette for DOM panels backed by the ui.xml parchment panels (see UiPanel.ts). Both
// panel_beige (#D3BF8F fill) and panel_beigeLight (#ECE3CE fill) are light/warm, so dark text
// is used throughout — the opposite of the dark-navy palette these panels replaced.
// textMuted and accent are tuned well past WCAG AA (>5.5:1) against panel_beige's #D3BF8F
// fill — the darker of the two panel backgrounds — so both stay crisp on panel_beigeLight too.
export const PARCHMENT = {
    text: "#4a3524", // primary text / headings
    textMuted: "#453a2d", // secondary text
    accent: "#5c3a10", // rank numbers, highlights, interactive accents
    divider: "rgba(74, 53, 36, 0.2)",
    highlightBg: "rgba(255, 255, 255, 0.4)",
    highlightBorder: "#5c3a10",
};
// z-index scale for the fixed-position DOM panels layered over the game canvas. Grouped by
// which panels can legitimately be open at once — entries sharing a number are always mutually
// exclusive (e.g. the build menu closes before placement mode's banner/toast can show).
export const LAYERS = {
    // Mobile leaderboard drawer
    leaderboardBackdrop: 89,
    resourceHud: 90,
    leaderboardToggle: 91,
    leaderboardPanel: 92,
    // Build menu / add-company modal (mutually exclusive with each other)
    buildMenuBackdrop: 95,
    addCompanyBackdrop: 95,
    placementBanner: 95,
    buildMenuPanel: 96,
    addCompanyPanel: 96,
    // Placement-error toast / destroy-confirm modal (mutually exclusive with each other)
    placementToast: 97,
    destroyConfirmBackdrop: 97,
    destroyConfirmPanel: 98,
    // Building identity: desktop hover tooltip vs mobile tap overlay — mutually exclusive by
    // platform, but kept at distinct values so paint order never depends on DOM insertion order.
    buildingTooltip: 100,
    buildingInfoOverlay: 101,
    // "My buildings" panel — above the tooltip/overlay layer
    userBuildingsBackdrop: 102,
    userBuildingsPanel: 103,
    connectionBanner: 999,
};
// Dark building-identity panel palette: BuildingTooltip.ts's desktop hover tooltip and
// BuildingInfoOverlay.ts's mobile tap replacement render identical content in near-identical
// markup, so they share this palette instead of each hand-rolling the same hex literals.
// Pre-dates the PARCHMENT redesign — kept as its own dark scheme rather than migrated, since
// converting these two panels to the light parchment look is a design decision, not a refactor.
export const BUILDING_PANEL = {
    background: "rgba(10, 11, 26, 0.96)",
    border: "rgba(160, 136, 96, 0.55)",
    divider: "rgba(160, 136, 96, 0.25)",
    title: "#f0e4cc",
    description: "#9a96b0",
    owner: "#6a667e",
    accent: "#c8a882", // visit hint/button
    danger: "#c87a7a", // destroy hint/button
};
// Destructive-action red, duplicated as a bare hex literal across several forms/modals
// (required-field markers, error text, danger buttons) before this token existed.
export const DANGER = "#a83a3a";
